<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.haberler.kategori.tanimlama.mainBaslik")}}
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <el-table
                            border
                            stripe
                            :data="kategoriListe"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Başlık"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="icon"
                                label="İcon"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="kategoriForm" :rules="rulesKategori" ref="kategoriForm"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item
                                            :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                            prop="baslik">:
                                        <div v-if="linkVisible" style="float: right; display: flex">
                                            <div v-if="!VisibleA">
                                                <el-link target="_blank" :underline="false"
                                                         :href="this.path">
                                                    {{this.path}}{{this.kategoriForm.link}}
                                                </el-link>
                                            </div>
                                            <el-button v-if="duzenleBtnVisible"
                                                       style="margin-left: 10px; margin-bottom: 5px"
                                                       v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                       size="mini">Düzenle
                                            </el-button>
                                            <span v-if="VisibleA">{{this.path}}</span>
                                            <el-input v-if="VisibleA" v-model="kategoriForm.link"
                                                      v-on:change="$store.commit('changeTabsClose', false);linkChange = false"
                                                      v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                      style="width: 50%" size="mini"></el-input>
                                        </div>
                                        <el-input
                                                :disabled="disabled"
                                                v-model="kategoriForm.baslik"
                                                v-on:change="linkTespit(); $store.commit('changeTabsClose', false);"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item
                                            label='Başlık (İngilizce)'
                                            prop="baslikEN">:
                                        <el-input
                                                :disabled="disabled"
                                                v-model="kategoriForm.baslikEN"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item class="margin-top-10">
                                        <el-button size="mini" type="success" v-on:click="iconListDialog = true"
                                                   icon="el-icon-search">İcon Seç
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="kategoriTanimlama('kategoriForm')"
                                           type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriEkle')}}
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('kategoriForm')" type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriGuncelle')}}
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('kategoriForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.rakamlar.islem.iconList")'
                :visible.sync="iconListDialog"
                width="60%"
                center>
            <div>
                <el-row class="iconRow">
                    <el-input class="margin-bottom-10" placeholder="Listede Olmayan Bir Icon Girebilirsiniz."  size="medium" v-model="kategoriForm.icon"></el-input>
                    <el-col v-for="(item,index) in iconListe"
                            :key="item"
                            :label="item"
                            :value="item" :lg="4" :md="4" :sm="8" :xs="8"
                            style="border: 1px solid #9a9a9a; padding: 5px; height: 100px; text-align: center;display:table">
                        <div v-on:click="iconSelect(item)" class="iconCerceve" id="#iconCerceve">
                            <el-button type="text">
                                <i style="font-size: 24px;text-align: center" :class="item"></i>
                            </el-button>
                            <br>
                            <span class="icon-name" :data-class="item">{{item}}</span>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-dialog>

        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" {{$t('src.views.apps.haberler.kategori.tanimlama.sil')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="projeDurumChange(selection,selectionIndex,kategoriListe,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import projeKategoriService from '../../../../WSProvider/ProjeKategoriService'
    import haberService from '../../../../WSProvider/HaberService'
    import seoService from '../../../../WSProvider/SeoService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';
    import iconJson from '../../../../icon'
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataExon = "";
    export default {
        name: "KategoriTanimlama",
        mounted() {
            this.getKategoriList();
        },
        data() {
            return {
                iconListe: iconJson["v5.0.9"],
                iconListDialog: false,
                kategoriListe: [],
                path: haberService.path,
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                kategoriForm: {
                    baslik: '',
                    baslikEN: '',
                    link: '',
                    icon: '',
                },
                rulesKategori: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            iconSelect(value) {
                this.kategoriForm.icon = value;
                $("body").find(".aktifIkon").removeClass("aktifIkon")
                $(".iconRow").find('span[data-class="' + value + '"]').closest(".iconCerceve").parent("div").addClass("aktifIkon");
                notification.Status("success", this, value + " iconu seçildi.")
            },
            linkTespitLink() {
                let self = this;
                if (this.kategoriForm.link) {
                    seoService.linkKontrol(self.kategoriForm.link.replace("'", "").substring(0, 55)).then((response) => {
                        if (response.status === 200) {
                            self.kategoriForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.kategoriForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.kategoriForm.baslik.replace("'", "").substring(0, 55)).then((response) => {
                        if (self.kategoriForm.baslik) {
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.kategoriForm.link = response.data;
                            }
                        } else if (!self.kategoriForm.baslik) {
                            self.linkVisible = false;
                            self.kategoriForm.link = '';
                        }
                    })
                }
            },
            getKategoriList() {
                projeKategoriService.pKategoriListesi(1).then((response) => {
                    if (response.status === 200) {
                        this.kategoriListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.kategoriForm.baslik = scope.baslik;
                this.kategoriForm.icon = scope.icon;
                this.kategoriForm.link = scope.link;
                this.updateKodu = scope.pkategoriId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            kategoriTanimlama(formName) {
                let dil = []
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.kategoriForm.baslikEN
                        };
                        projeKategoriService.pKategoriTanimlama(this.kategoriForm.link,this.kategoriForm.icon, this.kategoriForm.baslik,dil).then((response) => {
                            if (response.status === 200) {
                                this.kategoriListe.push(response.data);
                                notification.Status('success', this, 'Kategori başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                                this.kategoriForm.link = '';
                                this.linkVisible = false;
                                this.VisibleA = false;
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.kategoriForm.baslikEN
                        };
                        projeKategoriService.pKategoriGuncelle(this.updateKodu, this.kategoriForm.link, this.kategoriForm.icon, this.kategoriForm.baslik,dil).then((response) => {
                            if (response.status === 200) {
                                this.kategoriListe.splice(this.selectionIndex, 1);
                                this.kategoriListe.splice(this.selectionIndex, 0, {
                                    baslik: response.data.baslik,
                                    icon: response.data.icon,
                                    link: response.data.link,
                                    pkategoriId: response.data.pkategoriId
                                });
                                notification.Status('success', this, 'Kategori başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            projeDurumChange(selection, index, list,durum) {
                projeKategoriService.pKategoriDurumGuncelle(selection.pkategoriId,durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Kategori başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>

</style>